import{
  CREATING_CONTACT_LIST_REQUEST, CREATING_CONTACT_LIST_SUCCEDDED, CREATING_CONTACT_LIST_FAILED,
  UPDATING_CONTACT_LIST_REQUEST, UPDATING_CONTACT_LIST_SUCCEDDED, UPDATING_CONTACT_LIST_FAILED,
  DELETING_CONTACT_LIST_REQUEST, DELETING_CONTACT_LIST_SUCCEDDED, DELETING_CONTACT_LIST_FAILED,
  FETCHING_CONTACT_LIST_REQUEST, FETCHING_CONTACT_LIST_SUCCEDDED, FETCHING_CONTACT_LIST_FAILED,
  FETCHING_CONTACT_LISTS_REQUEST, FETCHING_CONTACT_LISTS_SUCCEDDED, FETCHING_CONTACT_LISTS_FAILED,
  ADD_CONTACT_TO_CONTACTLIST, REMOVE_CONTACT_FROM_CONTACTLIST,
  VIEW_CONTACT_LIST
} from './actionTypes.jsx';

import axios from 'axios';
import buildUrl from 'build-url-ts';

const apiUrl=process.env.REACT_APP_API_URL;

const API_BASE_URL = `${apiUrl}/api/2.0`;
const CONTACT_LISTS_URL = `${API_BASE_URL}/contact_lists`;

/** 
 * Creating Contact List
 */

export function createContactList(contactList) {
  return function (dispatch) {
    dispatch(creatingContactList());

    return axios({
      method: 'POST',
      url: CONTACT_LISTS_URL,
      data: contactList
    })
      .then(response => { 
        return dispatch(creatingContactListSUCCEDDED(response.data))
      })
      .catch(error => {
        return dispatch(creatingContactListFailed(error))
      })
  }
}

function creatingContactList() {
  return {
    type: CREATING_CONTACT_LIST_REQUEST,
    payload: {}
  }
}

function creatingContactListSUCCEDDED(json) {
  return {
    type: CREATING_CONTACT_LIST_SUCCEDDED,
    payload: json
  }
}

function creatingContactListFailed(error) {
  return {
    type: CREATING_CONTACT_LIST_FAILED,
    payload: error
  }
}

export function viewContactList(id) {
  return function (dispatch) {
    dispatch(viewingContactList(id));
  }
}

function viewingContactList(id) {
  return {
    type: VIEW_CONTACT_LIST,
    payload: id
  }
}

/**
 * Updating Contact List
 */

export function updateContactList(id, contactList) {
  return function (dispatch) {
    dispatch(updatingContactList(id));

    let url = buildUrl(CONTACT_LISTS_URL, {
      path: `${id}`
    });

    return axios({
      method: 'PUT',
      url: url,
      data: contactList
    })
      .then(response => {
        return dispatch(updatingContactListSuccedded(id, response.data))
      })
      .catch(error => {
        return dispatch(updatingContactListFailed(id, error))
      })
  }
}

function updatingContactList(id) {
  return {
    type: UPDATING_CONTACT_LIST_REQUEST,
    payload: id
  }
}

function updatingContactListSuccedded(id, json) {
  return {
    type: UPDATING_CONTACT_LIST_SUCCEDDED,
    payload: {
      id: id,
      contactList: json
    }
  }
}

function updatingContactListFailed(id, error) {
  return {
    type: UPDATING_CONTACT_LIST_FAILED,
    payload: {
      id: id,
      error: error
    }
  }
}

/**
 * Deleting Contact List
 */
export function deleteContactList(id) {
  return function (dispatch) {
    dispatch(deletingContactList());

    let url = buildUrl(CONTACT_LISTS_URL, {
      path: `${id}`
    });

    return axios({
      method: 'DELETE',
      url: url
    })
      .then(response => {
        return dispatch(deletingContactListSUCCEDDED(response.data))
      })
      .catch(error => {
        return dispatch(deletingContactListFailed(error))
      })
  }
}

function deletingContactList() {
  return {
    type: DELETING_CONTACT_LIST_REQUEST,
    payload: {}
  }
}

function deletingContactListSUCCEDDED(json) {
  return {
    type: DELETING_CONTACT_LIST_SUCCEDDED,
    payload: json
  }
}

function deletingContactListFailed(error) {
  console.log(error);
  return {
    type: DELETING_CONTACT_LIST_FAILED,
    payload: error
  }
}

/**
 * Fetching Contact List
 */
export function fetchContactList(id) {
  return function (dispatch) {
    dispatch(fetchingContactList(id));

    let url = buildUrl(CONTACT_LISTS_URL, {
      path: `${id}`
    });

    return axios({
      method: 'GET',
      url: url
    })
      .then(response => {
        return dispatch(fetchingContactListSUCCEDDED(id, response.data))
      })
      .catch(error => {
        return dispatch(fetchingContactListFailed(id, error))
      })
  }
}

function fetchingContactList(id) {
  return {
    type: FETCHING_CONTACT_LIST_REQUEST,
    payload: { id }
  }
}

function fetchingContactListSUCCEDDED(id, json) {
  return {
    type: FETCHING_CONTACT_LIST_SUCCEDDED,
    payload: {
      id: id,
      contactList: json
    }
  }
}

function fetchingContactListFailed(id, error) {
  console.log(error);
  return {
    type: FETCHING_CONTACT_LIST_FAILED,
    payload: {
      id: id,
      error: error
    }
  }
}

/**
 * Fetching Contact Lists
 */
export function fetchContactLists(page, query){
  return function (dispatch){
    dispatch(fetchingContactLists());

    let param = {
      query: query,
      page: page
    }

    return axios({
      method: 'GET',
      url: CONTACT_LISTS_URL,
      params: param
    })
      .then(response => {
        return dispatch(fetchingContactListsSUCCEDDED(response.data))
      })
      .catch(error => {
        return dispatch(fetchingContactListsFailed(error))
      })
  }
}

function fetchingContactLists() {
  return {
    type: FETCHING_CONTACT_LISTS_REQUEST,
    payload: {}
  }
}

function fetchingContactListsSUCCEDDED(json) {
  return {
    type: FETCHING_CONTACT_LISTS_SUCCEDDED,
    payload: json
  }
}

function fetchingContactListsFailed(error) {
  return {
    type: FETCHING_CONTACT_LISTS_FAILED,
    payload: error
  }
}

/**
 * Adding and Removing Contacts
 */

export function addContactToContactList(id, contact){
  return{
    type: ADD_CONTACT_TO_CONTACTLIST,
    payload: {
      id: id,
      contact: contact
    }
  }
 }

export function removeContactFromContactList(id, contact){
   return{
     type: REMOVE_CONTACT_FROM_CONTACTLIST,
     payload: {
       id: id,
       contact: contact
     }
   }
 }